"use client";

import { FC } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@mui/material/styles";

import { useStyles } from "./styles";
import { Image as TImage } from "@/types/thread";
import Image from "@/components/common/Image";
import useSafetyFilter from "@/hooks/useSafetyFilter";
import SafeSearchIndicator from "@/components/common/SafeSearchIndicator";

interface CarouselImageProps {
  image: TImage;
  isSelected: boolean;
  index: number;
  onSelect: (index: number) => void;
}

const CarouselImage: FC<CarouselImageProps> = ({
  image,
  isSelected,
  index,
  onSelect,
}) => {
  const { classes, cx } = useStyles();
  const blurImage = useSafetyFilter(image.safetyRating === 1);
  const isLargeScreen = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.up("lg")
  );

  const handleSelect = () => {
    onSelect(index);
  };

  if (!image?.url) return null;

  return (
    <div className={classes.container}>
      <Image
        src={image.url}
        alt={image.alt || ""}
        className={cx(
          classes.carouselImage,
          isSelected && classes.selectedCarouselImage
        )}
        onClick={handleSelect}
        style={{
          filter: blurImage ? "blur(15px)" : "none",
        }}
        width={isLargeScreen ? 125 : 75}
        height={isLargeScreen ? 125 : 75}
      />
      {blurImage && <SafeSearchIndicator />}
    </div>
  );
};

export default CarouselImage;
